export const ConsumerAuthenticationLoadingViewMessages = {
  loadingMessage: {
    id: 'Pages.ConsumerAuthentication.LoadingView.loadingMessage',
    description: 'loading message for consumer route resolver'
  }
}
